(function ($) {
  'use strict';

  $('.flip-container:not(.initialized)').each(function() {
    var $container = $(this).addClass('initialized'),
        $toggle = $container.find('.toggle'),
        flip_on_enter = false,
        flip_on_exit = false,
        over = false,
        timeout;


    $container
    .on('flip_on', function() {
      window.clearTimeout(timeout);
      $container.addClass('isflipping');
      timeout = window.setTimeout(function() {
        $container.addClass('notransition isflipped isflipping');
      }, 600);
    })
    .on('flip_off', function() {
      window.clearTimeout(timeout);
      $container.removeClass('isflipped');
      timeout = window.setTimeout(function() { 
        $container.removeClass('notransition isflipped isflipping');
      });
    })
    .on('mouseenter', function() {
      if (!flip_on_enter) {
        return;        
      }
      if (!over && !$container.hasClass('isflipping') && !$container.hasClass('isflipped')) {
        over = true;
        $container.trigger('flip_on');
      }
    })
    .on('mouseleave', function() {
      over = false;
      if (!flip_on_exit) {
        return;        
      }
      if ($container.hasClass('isflipping') || $container.hasClass('isflipped')) {
        $container.trigger('flip_off');
      }
    });

    $toggle
    .on('click', function(e) {
      //handle link inside flip text
      if(e.target.closest('a')) {
        return true;
      }
      e.preventDefault();
      if ($container.hasClass('isflipping') || $container.hasClass('isflipped')) {
        $container.trigger('flip_off');
      } else {
        $container.trigger('flip_on');
      }
      return false;
    });
  });

}(jQuery));
